import { types } from 'react-alert';
import { Check as SuccessIcon, Close as ErrorIcon } from 'components/icons';

export const Icon = {
  [types.SUCCESS]: <SuccessIcon width={24} height={24} />,
  [types.ERROR]: null,
  [types.INFO]: null,
};

export const Title = {
  [types.SUCCESS]: 'Success',
  [types.ERROR]: 'Error',
  [types.INFO]: 'Info',
};
